
  export const OFFER_INSTRUCTIONS = [
    "Meet in the main lobby upon arrival",
    "Check in with the team leader at the reception",
    "Gather at the designated meeting spot in parking lot B",
    "Please ensure proper identification upon arrival"
  ];

  export const ROLE_OPTIONS = [
    { value: "brandAmbassador", label: "Brand Ambassador" },
    { value: "member",          label: "Member" },
    { value: "fieldLeader",     label: "Field Leader" },
  ];
  